/**
 * Created by eliranm on 23/12/14.
 */
define(function (require) {
    'use strict';

    var LE = require('app');
    var BaseModel = require('models/BaseModel');
    var ContentImportErrorsModel = require('content-models/ContentImportErrorsModel');

    var ContentImportErrorsGridModel = {};
    LE.module('LEContent', function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentImportErrorsGridModel = BaseModel.extend({
            name: "ContentImportErrorsGridModel",
            defaults: {
                comparators: {
                    rowIndex: ContentImportErrorsModel.KEYS.rowIndex
                }
            }
        });
    });

    return ContentImportErrorsGridModel;
});
